import React from "react";
import { NextPage } from "next";
import { Header, MainContainer, WebsiteTerms, Footer2 } from "@components";
import Head from "next/head";
import { useToast } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { IUser } from "@redux/slices/user";
import { useSelector } from "react-redux";

const TermsPage: NextPage = () => {
    const toast = useToast();
    const user = useSelector((state: { user: IUser }) => state.user);
    const router = useRouter();
    return (
        <>
            <Head>
                <title>RoboEpics | آیین‌نامه سایت</title>
                <meta name="viewport" content="initial-scale=1.0, width=device-width" />
            </Head>
            <Header toast={toast} user={user} router={router} />
            <MainContainer>
                <WebsiteTerms />
            </MainContainer>
            <Footer2 />
        </>
    );
};

export default TermsPage;
